import React from 'react';

const Celebirity = () => {
    return (
        <div>
            Celebrity
        </div>
    );
};

export default Celebirity;